module.exports = __webpack_public_path__ + "img/product_bg_01_sc_01.c25be7c.png";